
//routes
export const typeRoute = "jazda";
export const typeRefuel = "tankowania";
export const typeZone = "rejonizacja";
export const typeWarning = "zdarzenia";
export const typeLayover = "postoje";

//identifier
export const tokenIdentifier = "X-API-KEY";

//api data names
export const apiRegistrationNo = "rejestracja";
export const apiCarDescription = "opis";
export const apiCarGroupId = "grupa_id";
export const apiCarBrandId = "marka_id";
export const apiCarModelId = "model_id";
export const apiCarFuelTypeId = "paliwo_id";
export const apiCarGearboxId = "skrzynia_biegow_id";
export const apiCarGprsId = "stan_gps";
export const apiRouteId = "trasa_id";
export const topEco = "eco";
export const worstEco = "nie-eco";
export const emptyDataResponse = "b.d.";

//time format
export const displayDateTimeFormat = "DD/MM/YYYY HH:mm:ss";
export const displayDateTimeWithoutSecondsFormat = "DD/MM/YYYY HH:mm";
export const displayDateFormat = "DD/MM/YYYY";
export const displayTimeWithSecondsFormat = "HH:mm:ss";
export const displayTimeWithoutSecondsFormat = "HH:mm";
export const dateTimePickerFormat = "YYYY-MM-DDTHH:mm:ss";
export const fullDayUnix = 86400;
//max date - 2100 year
export const maxDateRange =  4102448400;

//settingsView
//notifications row names
export const borderCrossed = "przekroczenie_granicy";
export const unauthorizedEngineEngageNotification = "nieautoryzowane_wlaczenie";
export const layoverNotification = "postoj";
export const deviceShiftNotification = "przelozenie_urzadzenia";
export const zoningNotification = "rejonizacja";
export const poolZoningNotification = "rejonizacja_pool";
export const disconnectionNotification = "rozlaczenia";
export const fuelDrainNotification = "spuszczenie";
export const overSpeedLimitNotification = "predkosc";
export const fuelReserve = "rezerwa";
//reminders row names
export const technicalInspectionReminder = "przeglad_techniczny";
export const insuranceReminder = "ubezpieczenie";
export const longLayoverReminder = "dlugi_postoj";


//other
export const sortAscending = "asc";
export const sortDescending = "desc";
export const indefinitePasswordExpiration = 1;